import { queryOptions } from '@tanstack/react-query';

import { buildURL, post } from '@/shared/fetch';

import { getQueryFn } from '../utils';
import { AnnouncementWithViewed, GetAnnouncementsQueryParams } from './types';

export const announcementsQueryKeyPrefix = ['announcements', 'list'] as const;

export const getAnnouncementsQueryOptions = (args?: GetAnnouncementsQueryParams) => {
  const params = { ...args, type: args?.type?.join(',') };
  return queryOptions({
    queryKey: ['announcements', 'list', params],
    queryFn: getQueryFn<{ list: AnnouncementWithViewed[] }>('/announcements', params),
    select: ({ list }) => list,
  });
};

export const viewAnnouncementMutationFn = (announcementId: string) => {
  return post<void>(buildURL(`/announcements/${announcementId}/viewed`));
};
